import * as React from "react";
import dayjs from "dayjs";
import LBox from "@components/LBox";
import LPressable from "@components/LPressable";
import LText from "@components/LText";

type StatsHeaderProps = {
  month: dayjs.Dayjs;
  onChangeMonth: (newMonth: dayjs.Dayjs) => void;
};

const StatsHeader = ({ month, onChangeMonth }: StatsHeaderProps) => {
  const changeMonth = (direction: "prev" | "next") => {
    const newMonth =
      direction === "prev" ? month.subtract(1, "month") : month.add(1, "month");
    onChangeMonth(newMonth);
  };

  return (
    <LBox
      backgroundColor={[
        "buttonBackgroundPrimaryLeft",
        "buttonBackgroundPrimaryRight",
      ]}
      gradientDirection="horizontal"
      width="100%"
      borderTopLeftRadius="l"
      borderTopRightRadius="l"
      borderBottomLeftRadius="zero"
      borderBottomRightRadius="zero"
      flexDirection="row"
      justifyContent="space-evenly"
      alignItems="center"
      height={52}
    >
      <LBox width="25%">
        <LPressable
          sentryEventName="stats_prev_month"
          onPress={() => changeMonth("prev")}
        >
          <LText variant="h4" textAlign="center" color="statsHeaderText">
            {"< " + month.subtract(1, "month").format("MMM YYYY")}
          </LText>
        </LPressable>
      </LBox>
      <LBox width="50%">
        <LText variant="h3" textAlign="center" color="statsHeaderText">
          {month.format("MMM YYYY")}
        </LText>
      </LBox>
      <LBox width="25%">
        {month.startOf("month") < dayjs().startOf("month") ? (
          <LPressable
            sentryEventName="stats_next_month"
            onPress={() => changeMonth("next")}
          >
            <LText variant="h4" textAlign="center" color="statsHeaderText">
              {month.add(1, "month").format("MMM YYYY") + " >"}
            </LText>
          </LPressable>
        ) : null}
      </LBox>
    </LBox>
  );
};

export default StatsHeader;
